// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JCaU","tabsBox":"styles_tabsBox__3xUQk","createButton":"styles_createButton__iqwRe"};